import React from "react";
import { useOrg } from "../../contexts/OrganizationContext";

function LocationConfirmation({ onConfirm, onCancel }) {
  const { organization } = useOrg();
  const stateName = organization.serviceLocale?.stateName || "your state";

  return (
    <div className="modal location-confirmation" role="dialog" tabIndex="-1" style={{ display: "block", marginTop: 220, zIndex: 9999 }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <a className="close-modal" aria-label="Close" onClick={onCancel} role="button" tabIndex={0}>
              <span aria-hidden="true">&times;</span>
            </a>

            <h3 className="sub-headliner">
              You didn't add a location.
            </h3>
            <p>
              Adding your location allows us to show resources near to you.
            </p>

            <div className="location-actions">
              <button className="btn search-all btn-default" onClick={onConfirm}>
                Search all {stateName}
              </button>
              <button className="add-location btn btn-primary" aria-label="Close" onClick={onCancel}>
                Add Location
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationConfirmation;
